















import { Component, Mixins } from 'vue-property-decorator'
import ModalBase from '@/components/common/molecules/ModalBase.vue'
import ModalBaseMethod from '@/mixins/ModalBaseMethod.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'

@Component({
  components: {
    ModalBase,
    ButtonBase,
  },
})
export default class ModalStudyConfirm extends Mixins(ModalBaseMethod) {
  private onClickOk() {
    this.$emit('click-ok')
  }
}
